// src/services/profile.js
import { api, setAccessToken, setStoredUser } from "./api";

/**
 * Cambiar contraseña (usuario autenticado).
 * Devuelve { access_token, user } y actualiza el storage local.
 */
export async function changePassword(currentPassword, newPassword, remember = false) {
  const data = await api.post("/auth/change-password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
  // El backend devuelve access_token rotado y (opcional) user
  if (data?.access_token) setAccessToken(data.access_token, remember);
  if (data?.user) setStoredUser(data.user, remember);
  return data;
}

/**
 * Enviar email de restablecimiento (login → “Olvidé mi contraseña”).
 */
export function requestPasswordReset(email) {
  return api.post("/auth/forgot-password", { email });
}

/**
 * Completar restablecimiento con token (pantalla /reset?token=...).
 */
export function resetPassword(token, newPassword) {
  return api.post("/auth/reset-password", {
    token,
    new_password: newPassword,
  });
}

/**
 * Admin → Enviar email de restablecimiento a un usuario concreto.
 */
export function adminSendReset(userId) {
  return api.post(`/auth/users/${userId}/password/send-reset`);
}

/**
 * (Opcional) Admin → Establecer nueva contraseña directamente.
 */
export function adminSetPassword(userId, newPassword) {
  return api.post(`/auth/users/${userId}/password/set`, { new_password: newPassword });
}
